(() => {
  if (window.__NC_CART_CLEANUP_V2) return;
  window.__NC_CART_CLEANUP_V2 = true;
  const SIZE_NAMES = new Set(['afmeting', 'maat', 'maten', 'size', 'formaat']);
  let busy = false;
  function forceVisible() {
    document.querySelectorAll('form.cart__contents.critical-hidden').forEach((el) => el.classList.remove('critical-hidden'));
  }
  function normalizeSizes(root = document) {
    root.querySelectorAll('.product-option').forEach((row) => {
      const dt = row.querySelector('dt'); const dd = row.querySelector('dd');
      if (!dt || !dd) return;
      const name = dt.textContent.replace(':', '').trim().toLowerCase();
      if (!SIZE_NAMES.has(name)) return;
      const value = dd.textContent.trim();
      const match = value.match(/^(\d{2,3})\s*[x×X]\s*(\d{2,3})(?:\s*cm)?\s*,?$/i);
      if (match) dd.textContent = `${match[1]} × ${match[2]} cm`;
    });
  }
  async function applyCleanup() {
    forceVisible();
    if (busy) return; busy = true;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      cart.items.forEach((item, index) => {
        const props = item.properties || {};
        const isAddon = props._nc_addon === true || String(props._nc_addon).toLowerCase() === 'true';
        if (!isAddon) return;
        const pageRow = document.getElementById(`CartItem-${index + 1}`);
        const drawerRow = document.getElementById(`CartDrawer-Item-${index + 1}`);
        if (pageRow) pageRow.style.display = 'none';
        if (drawerRow) drawerRow.style.display = 'none';
      });
      normalizeSizes(document); forceVisible();
    } catch (_) { normalizeSizes(document); forceVisible(); }
    finally { busy = false; }
  }
  function scheduleCleanup(delay = 150) { window.clearTimeout(window.__ncCartCleanupTimer); window.__ncCartCleanupTimer = window.setTimeout(applyCleanup, delay); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyCleanup, { once: true }); else applyCleanup();
  window.addEventListener('load', forceVisible, { once: true });
  document.addEventListener('shopify:section:load', () => scheduleCleanup(20));
  document.addEventListener('change', (event) => { if (event.target.closest('cart-items, cart-drawer-items')) scheduleCleanup(250); });
  document.addEventListener('click', (event) => { if (event.target.closest('quantity-input, cart-remove-button')) scheduleCleanup(350); });
  new MutationObserver(forceVisible).observe(document.documentElement,{childList:true,subtree:true});
})();